
<template>
  <div class="statsBox">
    <div v-for="(stat, index) in items" :key="index" class="statsCard">
      <h1 class="statsNum">{{stat.num}}</h1>
      <h2 class="statsLabel">{{stat.label}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["items"]
};
</script>

<style lang="scss">
@import "./Stats.scss";
</style>